import { typedAction } from 'store/modules/base';
import { Field } from 'm2m.components';
import { Dispatch } from 'redux';
import { PUTDistribuirLote, POSTInstrumentosCoordenadores, GETQuantidadeDelimitadaPorCoordenador, PUTAtualizarCoordenadoresCompleto, POSTExportarMapaAlocacao } from 'requests/coordenadores';
import { Coordenador, DelimitacaoCoordenadorResponse, DistribuirLoteRequest, PostInstrumentosCoordenadoresRequest, AtualizarCoordenadoresRequest } from 'common/genericTypes';

export interface CoordenadoresState {
    coordenadores: Coordenador[];
    tipoDelimitacao: 'VALOR' | 'QUANTIDADE';
    putDistribuirLote: (dispatch: Dispatch, instrumentoGuId: string, distribuirLoteRequest: DistribuirLoteRequest, stackRequest?: boolean) => Promise<any>;
    postInstrumentosCoordenadores: (dispatch: Dispatch, filter: PostInstrumentosCoordenadoresRequest, stackRequest?: boolean) => Promise<any>;
    getQuantidadeDelimitadaPorCoordenador: (dispatch: Dispatch, instrumentoFinanceiroGuid: string, stackRequest?: boolean) => Promise<Array<DelimitacaoCoordenadorResponse>>;
    putAtualizarCoordenadoresCompleto: (dispatch: Dispatch, instrumentoFinanceiroCodigo: string, atualizarCoordenadoresRequest: AtualizarCoordenadoresRequest, stackRequest?: boolean) => Promise<any>;
    postExportarMapaAlocacao: (dispatch: Dispatch, filter: PostInstrumentosCoordenadoresRequest, stackRequest?: boolean) => Promise<any>;
}

export const coordenadoresInitialState: CoordenadoresState = {
    coordenadores: [],
    tipoDelimitacao: 'VALOR',
    putDistribuirLote: PUTDistribuirLote,
    postInstrumentosCoordenadores: POSTInstrumentosCoordenadores,
    getQuantidadeDelimitadaPorCoordenador: GETQuantidadeDelimitadaPorCoordenador,
    putAtualizarCoordenadoresCompleto: PUTAtualizarCoordenadoresCompleto,
    postExportarMapaAlocacao: POSTExportarMapaAlocacao
};

export const updateField = (field: Field) => {
    return typedAction('coordenadores/UPDATEFIELD', field);
};

export const resetCoordenadores = () => {
    return typedAction('coordenadores/RESET');
};

export const updateCoordenadores = (state: CoordenadoresState) => {
    return typedAction('coordenadores/UPDATE', state);
};

export type CoordenadoresAction = ReturnType<
    | typeof updateField
    | typeof updateCoordenadores
    | typeof resetCoordenadores
>;
